var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map((function(p){return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = function(scopeName, key) {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = function(scope, key) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key) {
	var versions = scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = function(scope, key, requiredVersion) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = function(scope, scopeName, key, requiredVersion) {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = function(scope, scopeName, key, requiredVersion) {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var init = function(fn) { return function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
}; };

var load = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	79311: function() { return loadSingletonVersionCheckFallback("default", "react-dom", [1,18,3,1], function() { return function() { return __webpack_require__(54164); }; }); },
	22023: function() { return loadStrictVersionCheckFallback("default", "@nivo/core", [2,0,74,0], function() { return Promise.all([__webpack_require__.e(4179), __webpack_require__.e(1636), __webpack_require__.e(8109), __webpack_require__.e(4357)]).then(function() { return function() { return __webpack_require__(54357); }; }); }); },
	71811: function() { return loadSingletonVersionCheckFallback("default", "mobx", [1,6,6,0], function() { return __webpack_require__.e(4098).then(function() { return function() { return __webpack_require__(84098); }; }); }); },
	98125: function() { return loadStrictVersionCheckFallback("default", "apexcharts", [1,3,53,0], function() { return __webpack_require__.e(8700).then(function() { return function() { return __webpack_require__(88700); }; }); }); },
	2161: function() { return loadStrictVersionCheckFallback("default", "d3", [1,6,7,0], function() { return Promise.all([__webpack_require__.e(5505), __webpack_require__.e(4179), __webpack_require__.e(2359), __webpack_require__.e(4690), __webpack_require__.e(7325), __webpack_require__.e(4980)]).then(function() { return function() { return __webpack_require__(64980); }; }); }); },
	334: function() { return loadStrictVersionCheckFallback("default", "react-router-dom", [1,5,2,0], function() { return __webpack_require__.e(6580).then(function() { return function() { return __webpack_require__(6580); }; }); }); },
	5284: function() { return loadStrictVersionCheckFallback("default", "@idui/react-popover", [1,3,1,0], function() { return Promise.all([__webpack_require__.e(9286), __webpack_require__.e(9311)]).then(function() { return function() { return __webpack_require__(39286); }; }); }); },
	9704: function() { return loadStrictVersionCheckFallback("default", "react-month-picker", [1,2,2,1], function() { return __webpack_require__.e(8717).then(function() { return function() { return __webpack_require__(48717); }; }); }); },
	14849: function() { return loadStrictVersionCheckFallback("default", "react-apexcharts", [1,1,4,1], function() { return __webpack_require__.e(3496).then(function() { return function() { return __webpack_require__(13496); }; }); }); },
	31177: function() { return loadStrictVersionCheckFallback("default", "snapsvg-cjs", [4,0,0,6], function() { return __webpack_require__.e(4651).then(function() { return function() { return __webpack_require__(64651); }; }); }); },
	31783: function() { return loadStrictVersionCheckFallback("default", "react-d3-speedometer", [1,1,0,1], function() { return __webpack_require__.e(7793).then(function() { return function() { return __webpack_require__(17793); }; }); }); },
	31996: function() { return loadStrictVersionCheckFallback("default", "multi-range-slider-react", [1,2,0,2], function() { return __webpack_require__.e(4263).then(function() { return function() { return __webpack_require__(64263); }; }); }); },
	45748: function() { return loadStrictVersionCheckFallback("default", "react-bootstrap", [2,0,33,1], function() { return Promise.all([__webpack_require__.e(7145), __webpack_require__.e(9311)]).then(function() { return function() { return __webpack_require__(87145); }; }); }); },
	53189: function() { return loadStrictVersionCheckFallback("default", "react-table", [1,7,8,0], function() { return __webpack_require__.e(1358).then(function() { return function() { return __webpack_require__(71358); }; }); }); },
	54978: function() { return loadStrictVersionCheckFallback("default", "@nivo/line", [2,0,79,1], function() { return Promise.all([__webpack_require__.e(5505), __webpack_require__.e(3368), __webpack_require__.e(4179), __webpack_require__.e(1636), __webpack_require__.e(4690), __webpack_require__.e(6350), __webpack_require__.e(7325), __webpack_require__.e(2211), __webpack_require__.e(9311), __webpack_require__.e(2023)]).then(function() { return function() { return __webpack_require__(72211); }; }); }); },
	56391: function() { return loadStrictVersionCheckFallback("default", "react-error-boundary", [1,3,1,4], function() { return __webpack_require__.e(7470).then(function() { return function() { return __webpack_require__(77470); }; }); }); },
	57510: function() { return loadStrictVersionCheckFallback("default", "react-select", [1,5,2,1], function() { return Promise.all([__webpack_require__.e(9861), __webpack_require__.e(9311)]).then(function() { return function() { return __webpack_require__(29861); }; }); }); },
	65177: function() { return loadStrictVersionCheckFallback("default", "@nivo/bar", [2,0,74,1], function() { return Promise.all([__webpack_require__.e(5505), __webpack_require__.e(3368), __webpack_require__.e(4179), __webpack_require__.e(1636), __webpack_require__.e(4690), __webpack_require__.e(6350), __webpack_require__.e(8109), __webpack_require__.e(6298), __webpack_require__.e(9311), __webpack_require__.e(2023)]).then(function() { return function() { return __webpack_require__(66298); }; }); }); },
	65564: function() { return loadStrictVersionCheckFallback("default", "axios", [2,0,27,2], function() { return __webpack_require__.e(4569).then(function() { return function() { return __webpack_require__(74569); }; }); }); },
	77265: function() { return loadStrictVersionCheckFallback("default", "react-switch", [1,7,0,0], function() { return __webpack_require__.e(7842).then(function() { return function() { return __webpack_require__(67842); }; }); }); },
	83134: function() { return loadStrictVersionCheckFallback("default", "@syncfusion/ej2-react-grids", [1,27,1,50], function() { return Promise.all([__webpack_require__.e(100), __webpack_require__.e(9311)]).then(function() { return function() { return __webpack_require__(10100); }; }); }); },
	83415: function() { return loadStrictVersionCheckFallback("default", "@nivo/pie", [2,0,79,1], function() { return Promise.all([__webpack_require__.e(5505), __webpack_require__.e(3368), __webpack_require__.e(9098), __webpack_require__.e(9311), __webpack_require__.e(2023)]).then(function() { return function() { return __webpack_require__(19098); }; }); }); },
	91504: function() { return loadSingletonVersionCheckFallback("default", "mobx-react", [1,7,5,0], function() { return Promise.all([__webpack_require__.e(8907), __webpack_require__.e(9311)]).then(function() { return function() { return __webpack_require__(8907); }; }); }); },
	46058: function() { return loadSingletonVersionCheckFallback("default", "react", [1,18,3,1], function() { return function() { return __webpack_require__(72791); }; }); }
};
var initialConsumes = [46058];
initialConsumes.forEach(function(id) {
	__webpack_require__.m[id] = function(module) {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"1811": [
		71811
	],
	"2023": [
		22023
	],
	"2161": [
		2161
	],
	"3496": [
		98125
	],
	"9311": [
		79311
	],
	"9723": [
		334,
		5284,
		9704,
		14849,
		31177,
		31783,
		31996,
		45748,
		53189,
		54978,
		56391,
		57510,
		65177,
		65564,
		77265,
		83134,
		83415,
		91504
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}